import { render } from "./confirm.vue?vue&type=template&id=4fe31b49"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
script.render = render

export default script